import stickerResource from "../resources/StickerResource";
import { BaseRepositoryBuilder } from "../../../../infrastructure/BaseRepositoryBuilder";
import { StickerCommentRepository } from "../repositories/StickerCommentRepository";

class StickerCommentRepositoryBuilder extends BaseRepositoryBuilder {
  constructor() {
    super(StickerCommentRepository);
  }

  public buildWithSticker(sticker) {
    const resource = stickerResource.child(sticker.id, 'comments');
    return this.build(resource);
  }
}

const stickerCommentRepositoryBuilder = new StickerCommentRepositoryBuilder();
export default stickerCommentRepositoryBuilder;


// WEBPACK FOOTER //
// ./src/app/modules/stickers/domain/factories/StickerCommentsRepositoryBuilder.ts